import { gql } from '@apollo/client';

// Includes sum of totals from all departments (last item in return [])
export const getFullOITHardwareDeviceReport = gql`
  query {
    getFullOITHardwareDeviceReport {
      deptName
      numDesktopsToRefresh
      totalDesktops
      numLaptopsToRefresh
      totalLaptops
      numIpadsToRefresh
      totalIpads
      numTabletsToRefresh
      totalTablets
      numDevicesToRefresh
      totalDevices
      avgYrsOld
      deptId
    }
  }
`;

export const PerFYDeviceRefreshReport = gql`
  query getUpcomingRefreshReportv2($year: Float!) {
    getUpcomingRefreshReportv2(year: $year) {
      Laptops
      Desktops
      Tablets
      iPads
      departmentName
      Refresh_FY
    }
  }
`;

export const pagePerFYDeviceRefreshReport = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!], $csv: Boolean) {
    pageUpcomingRefreshReport(grid: { amount: $amount, field: $field, page: $page, filters: $filters, csv: $csv }) {
      count
      data {
        departmentName
        Tablets
        Desktops
        Laptops
        iPads
      }
    }
  }
`;

export const getFullOITHardwareDeviceReport_6yrs = gql`
  query {
    getFullOITHardwareDeviceReport_6yrs {
      deptName
      numDesktopsToRefresh
      totalDesktops
      numLaptopsToRefresh
      totalLaptops
      numIpadsToRefresh
      totalIpads
      numTabletsToRefresh
      totalTablets
      numDevicesToRefresh
      totalDevices
      avgYrsOld
      deptId
    }
  }
`;

// Query for device totals per deptId arg
export const queryPerDeptRefresh = gql`
  query ($deptId: Float!, $sixYears: Boolean) {
    queryDeviceRefreshByDept(deptId: $deptId, sixYears: $sixYears) {
      barCode
      assetNumber
      description1
      description2
      description3
      yrsOld
      needRefresh
      departmentId
      departmentName
    }
  }
`;

export const queryPerDeptRefresh_6yrs = gql`
  query ($deptId: Float!, $sixYears: boolean) {
    queryDeviceRefreshByDept_6yrs(deptId: $deptId, sixYears: sixYears) {
      barCode
      assetNumber
      description1
      description2
      description3
      yrsOld
      needRefresh
      departmentId
      departmentName
    }
  }
`;
